const masterSectionsGroups =
  [
    {
      name: 'users',
      title: 'MASTERS.USERS'
    },
    {
      name: 'organizedUnits',
      title: 'MASTERS.OU'
    },
    {
      name: 'documents',
      title: 'MASTERS.DOCUMENTS'
    },
    {
      name: 'dossiers',
      title: 'MASTERS.DOSSIERS'
    },
    {
      name: 'entities',
      title: 'MASTERS.ENTITIES'
    },
    {
      name: 'vehicles',
      title: 'MASTERS.VEHICLES'
    },
    {
      name: 'paperworks',
      title: 'MASTERS.PAPERWORKS'
    },
    {
      name: 'campaigns',
      title: 'MASTERS.CAMPAIGNS'
    },
    {
      name: 'services',
      title: 'MASTERS.SERVICES'
    },
    {
      name: 'other',
      title: 'MASTERS.OTHER'
    }
  ]

export default masterSectionsGroups
